import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const FNOLLifecycleChart = ({ data, loading }) => {
    // Transform API data to chart format
    const chartData = data && data.timeline 
        ? data.timeline.map(item => ({
            name: item.period_label,
            received: item.fnols_received,
            completed: item.fnols_completed,
            pending: item.fnols_pending,
            slaBreach: item.sla_breaches > 0 ? item.sla_breaches : null
        }))
        : [];

    if (loading) {
        return (
            <div className="h-full flex flex-col items-center justify-center">
                <h2 className="text-xl font-bold text-gray-900 mb-1">FNOLs Lifecycle Over Time</h2>
                <p className="text-sm text-gray-500 mb-6 font-medium">FNOLs Lifecycle Over Time</p>
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }
    return (
        <div className="h-full flex flex-col items-center w-full">
            <h2 className="text-xl font-bold text-gray-900 mb-1">FNOLs Lifecycle Over Time</h2>
            <p className="text-sm text-gray-500 mb-6 font-medium">FNOLs Lifecycle Over Time</p>
            <div className="w-full h-[300px] bg-[#f8f9fa] rounded-lg p-2">
                <ResponsiveContainer width="100%" height="98%">
                    <LineChart
                        data={chartData}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 20,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                        <XAxis
                            dataKey="name"
                            tick={{ fontSize: 11, fill: '#374151' }}
                            axisLine={false}
                            tickLine={false}
                            dy={10}
                            label={{ value: 'Month', position: 'insideBottom', offset: -20, fontSize: 11 }}
                        />
                        <YAxis
                            tick={{ fontSize: 11, fill: '#374151' }}
                            axisLine={false}
                            tickLine={false}
                            label={{
                                value: 'Number of FNOLs',
                                angle: -90,
                                position: 'insideLeft',
                                style: { textAnchor: 'middle', fontSize: '11px', fill: '#6B7280' },
                                dx: -10
                            }}
                        />
                        <Tooltip />
                        <Legend
                            verticalAlign="top"
                            align="left"
                            iconType="circle"
                            wrapperStyle={{ paddingBottom: '20px', paddingLeft: '40px', fontSize: '13px' }}
                        />
                        <Line
                            type="linear"
                            dataKey="received"
                            name="FNOLs Received"
                            stroke="#93C5FD"
                            strokeWidth={3}
                            dot={{ r: 4, fill: '#93C5FD' }}
                        />
                        <Line
                            type="linear"
                            dataKey="completed"
                            name="FNOLs Completed"
                            stroke="#FCA5A5"
                            strokeWidth={3}
                            dot={{ r: 4, fill: '#FCA5A5' }}
                        />
                        <Line
                            type="linear"
                            dataKey="pending"
                            name="FNOLs Pending"
                            stroke="#FCD34D"
                            strokeWidth={3}
                            dot={{ r: 4, fill: '#FCD34D' }}
                        />
                        <Line
                            type="linear"
                            dataKey="slaBreach"
                            name="SLA Breach"
                            stroke="#EF4444"
                            strokeWidth={0}
                            dot={{ r: 6, fill: '#EF4444', stroke: 'none' }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default FNOLLifecycleChart;
